module.exports = __webpack_public_path__ + "static/media/me-about.7293c924.jpg";